import { useEffect, useState } from "react";
import { useDragger, getPostionCSSClass } from "../../../helper";
import { getCloseButtonStyles } from "../utils/closeButtonStyles";


const HTMLEmbeddingDraggableNudge = ({
  customizeState,
  nudgeId,
  setNudgePosition,
  id,
  setCustomizeState,
}) => {
  // console.log("---> customizeState <---", customizeState);
  const [userNudge_OfferTextFinal, setUserNudge_OfferTextFinal] = useState("");
  let left = 0;
  let top = 0;
  if (id === "desktop") {
    left = customizeState?.nudge?.desktopNudgePosition?.left;
    top = customizeState?.nudge?.desktopNudgePosition?.top;
  } else {
    top = customizeState?.nudge?.mobileNudgePosition?.top;
  }


  let hour = "00";
  let minute = "00";
  let timer = `${hour}:${minute}:00 hours`;

  let timeInMinute = customizeState?.nudgeOfferText?.minutes
    ? +customizeState?.nudgeOfferText?.minutes
    : 0;

  if (timeInMinute >= 60) {
    // add 0 before single digit
    hour = timeInMinute / 60;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = timeInMinute % 60;
    minute = minute < 10 ? `0${minute}` : minute;
    timer = `${hour}:${minute}:00 hours`;
  } else {
    timeInMinute = timeInMinute < 10 ? `0${timeInMinute}` : timeInMinute;
    timer = `${timeInMinute}:00 minutes`;
  }
  useEffect(() => {
    let userNudge_offerText = customizeState?.nudgeOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.nudgeOfferText?.minutes;
    setUserNudge_OfferTextFinal(
      userNudge_offerText?.replace("{time}", userNudge_ExpiryTime)
    );
  }, [customizeState?.nudgeOfferText]);


  return (
    <div className={`h-full flex justify-center items-center`}>
      <div
        id={`nudgeID${nudgeId + id}`}
        className="nudge shadow-md p-3 flex justify-center flex-col gap-3 w-40 text-center select-none"
        style={{
          backgroundColor: `${customizeState?.nudge?.backgroundColor}`,
          borderWidth: `${customizeState?.nudge?.borderWidth}px`,
          borderColor: `${customizeState?.nudge?.borderColor}`,
          borderStyle: `${customizeState?.nudge?.borderStyle}`,
          borderRadius: `${customizeState?.nudge?.borderRadius}px`,
          position: "absolute",
          overflow: "visible",
          marginLeft: `${customizeState?.nudgePosition?.margin_left}px`,
          marginTop: `${customizeState?.nudgePosition?.margin_top}px`,
          marginRight: `${customizeState?.nudgePosition?.margin_right}px`,
          marginBottom: `${customizeState?.nudgePosition?.margin_bottom}px`,
          width: "90%",
        }}
      >
        <HTMLEmbeddingNudgeUI
          customizeState={customizeState}
          userNudge_OfferTextFinal={userNudge_OfferTextFinal}
        />
      </div>
    </div>
  );
};

export default HTMLEmbeddingDraggableNudge;


const HTMLEmbeddingNudgeUI = ({ customizeState, userNudge_OfferTextFinal }) => {
  return (
    <>
      <div className="flex justify-center items-center flex-wrap gap-4">
        {customizeState?.mediaFields?.mediaType === "image" ? (
          <>
            {Array.from({ length: 3 }, (_, i) => (
              <img
                key={i}
                src={
                  customizeState?.mediaFields?.[`mediaInputField_${i + 1}`][1]
                }
                alt={`banner hero img ${i + 1}`}
                className="w-[260px] object-cover"
                style={{
                  backgroundColor:
                    customizeState?.mediaFields?.backgroundColor || "white",
                  borderWidth: `${
                    customizeState?.mediaFields?.borderWidth || 0
                  }px`,
                  borderColor:
                    customizeState?.mediaFields?.borderColor || "black",
                  borderStyle:
                    customizeState?.mediaFields?.borderStyle || "solid",
                  borderRadius: `${
                    customizeState?.mediaFields?.borderRadius || 0
                  }px`,
                  display: customizeState?.mediaFields?.[
                    `mediaInputField_${i + 1}`
                  ]?.[0]
                    ? "block"
                    : "none",
                }}
              />
            ))}
          </>
        ) : (
          <>
            {Array.from({ length: 3 }, (_, i) => (
              <video
                key={i}
                src={
                  customizeState?.mediaFields?.[`mediaInputField_${i + 1}`][1]
                }
                className="w-[300px] object-cover"
                controls
                style={{
                  backgroundColor:
                    customizeState?.mediaFields?.backgroundColor || "white",
                  borderWidth: `${
                    customizeState?.mediaFields?.borderWidth || 0
                  }px`,
                  borderColor:
                    customizeState?.mediaFields?.borderColor || "black",
                  borderStyle:
                    customizeState?.mediaFields?.borderStyle || "solid",
                    borderRadius: `${
                      customizeState?.mediaFields?.borderRadius || 0
                    }px`,
                  display: customizeState?.mediaFields?.[
                    `mediaInputField_${i + 1}`
                  ]?.[0]
                    ? "block"
                    : "none",
                }}
              />
            ))}
          </>
        )}
      </div>
      <p
        className="text-lg text-gray-800 break-words"
        style={{
          display: `${customizeState?.nudgeOfferText?.display}`,
          fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
          color: `${customizeState?.nudgeOfferText?.textColor}`,
        }}
      >
        <span className="nudgeText">{userNudge_OfferTextFinal}</span>
      </p>
      <p
        className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer max-w-max mx-auto"
        style={{
          fontStyle: `${customizeState?.nudgeCopyCode?.fontStyle}`,
          color: `${customizeState?.nudgeCopyCode?.textColor}`,
          backgroundColor: `${customizeState?.nudgeCopyCode?.backgroundColor}`,
          borderWidth: `${customizeState?.nudgeCopyCode?.borderWidth}px`,
          borderColor: `${customizeState?.nudgeCopyCode?.borderColor}`,
          borderStyle: `${customizeState?.nudgeCopyCode?.borderStyle}`,
          borderRadius: `${customizeState?.nudgeCopyCode?.borderRadius}px`,
        }}
      >
        {customizeState?.nudgeCopyCode?.text}
      </p>
      <p
        className="mt-[-14px]"
        style={{
          fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
          color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
          fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
          display: `${customizeState?.nudgeDisclaimerText?.display}`,
        }}
      >
        {customizeState?.nudgeDisclaimerText?.text}
      </p>
      <span
        className="crossicon absolute top-1 font-bold right-2 cursor-pointer text-xs"
        style={getCloseButtonStyles(customizeState)}
      >
        X
      </span>
    </>
  );
};


